<template>
    <img
        :src="image"
        :alt="alt"
    >
</template>

<script>
export default {
    props: {
        alt: {
            type: String,
            default: "Error!",
            required: false
        }
    },
    computed: {
        image() {
            return require("../../assets/images/error_bus.svg");
        }
    }
};
</script>
